<template>
  <div
    class="product-upload"
    :style="{ '--borderColor': borderColor, '--textColor': textColor, 
      '--inputBacgroundColor': inputBacgroundColor }"
  >
    <div class="poz_rel">
      <div
        class="wrapper_file_upload"
        :class="{ highlight: highlight }"
        @dragover.prevent
        @drop.stop.prevent="handleDrop"
        @dragenter.stop.prevent="onDragEnter"
        @dragleave.stop.prevent="onDragLeave"
      >
        <label v-show="!selectedFile" class="file_upload">
          <input
            @change="onFilePicked"
            accept="image/*,application/pdf"
            class="inputfile"
            type="file"
            name="file"
            ref="file"
          />
          <div class="upload_content">
            <h3>
              Incarca poza <br />
              produsului
            </h3>
            <span class="d-none d-lg-block"
              >Trage si plaseaza imaginea sau fa click aici</span
            >
          </div>
          <button-component
            id="button"
            text="Incarca"
            :addClass="buttonClass"
            method="selectAnother"
          />
        </label>
        <label v-show="selectedFile" class="image_preview">
          <img
            class="square-img img-fluid"
            ref="preview"
            src="../../assets/icons/placeholder.svg"
            alt
          />
          <!-- <button-component
            class="chooseButton"
            text="Selecteaza un alt fisier"
            addClass="btn-yellow"
            method="selectAnother"
          /> -->
          <div @click="removeImage" class="delete_block">
            <img class="delete_img" src="../../assets/icons/delete.svg" alt="Delete" />
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-upload",
  props: {
    fieldId: String,
    endpoint: String,
    successAction: {
      type: Object,
      required: true
    },
    value: {
      required: false
    },
    title: {
      type: String,
      default: "Laden Sie Ihr Foto hoch"
    },
    uploadText: {
      type: String,
      default: "Alegeti un fisier"
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#8B8B8B"
    },
    inputBacgroundColor: {
      required: false,
      type: String,
      default: "#fbfcfe"
    },
    tokenName: {
      required: false,
      type: String,
      default: "token"
    },
    reUpload: {
      required: false,
      type: Boolean
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    borderColor: {
      required: false,
      type: String,
      default: ""
    },
    textColor: {
      required: false,
      type: String,
      default: "#0f2967"
    },
    buttonClass: {
      required: false,
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedFile: null,
      uploadSectionHover: false,
      highlight: false
    };
  },
  components: {},
  methods: {
    clear() {
      this.selectedFile = null;
      this.setValue(null);
    },
    removeImage() {
      this.selectedFile = null;
      this.setValue(null);
      this.$refs.file.value = null;
    },
    onFilePicked(event) {
      const files = event.target.files || event.dataTransfer.files;
      this.handleFiles(files);
    },
    onDragEnter() {
      this.highlight = true;
    },
    onDragLeave() {
      this.highlight = false;
    },
    handleDrop(e) {
      let dt = e.dataTransfer;
      let files = dt.files;
      this.handleFiles(files);
    },
    handleFiles(files) {
      const maxfilesize = 1024 * 1024 * 16; // 1 Mb

      if (files && files[0]) {
        let filename = files[0].name;

        if (filename && filename.lastIndexOf(".") <= 0) {
          return;
        }
        if (files[0].size > maxfilesize) {
          this.showModal(this.texts.fileSizeLimit);
          return;
        }
        const extension = files[0].name.split(".").pop();
        const found = ["png", "jpg", "jpe", "jpeg", "tiff", "pdf"].filter(
          (ext) => ext === extension.toLowerCase()
        );
        if (!found.length) {
          this.showModal(this.texts.wrongFormat);
          return;
        }
        this.selectedFile = files[0];
        this.setPreview(this.selectedFile);
        this.setValue(this.selectedFile);
      }
    },
    setValue(value) {
      this.$emit("component-updated", {
        value
      });
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: !!value
      });
    },
    setPreview(file) {
      const reader = new FileReader();

      this.selectedFile = file;
      reader.onload = (e) => {
        this.$refs.preview.src = e.target.result;
      };

      reader.readAsDataURL(file);
    },
    sendProductPhoto(formId, triggers) {
      const formData = {
        image: this.selectedFile,
        endpoint: this.endpoint,
        receiptToken: this.$store.getters.receiptToken
      };

      if (this.reUpload) {
        formData["receiptToken"] = this.$route.query[this.tokenName];
        formData["customerToken"] = 1;
        // console.log("REUPLOAD",this.reUpload, formData)
      }

      this.$store.dispatch("uploadProductPhotos", formData).then((r) => {
        // console.log(this.successAction, this.response);
        if (r.response && this.successAction) {
          const fn = this.successAction.fn;
          const params = this.successAction.params;
          this[fn](params, this);
          this.$eventHub.$emit("done-event-trigger", {
            parent: this,
            status: true
          });
        }
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false,
          message: r.message || "Unexpected Error",
          invalid_fields: r.invalid_fields || []
        });
      });
    },
    selectAnother() {
      this.$refs.file.click();
    }
  },
  mounted() {
    if (this.value) {
      this.setPreview(this.value);
    }
    this.$eventHub.$on("sendProductPhotos-event", this.sendProductPhoto);
    this.$eventHub.$on("selectAnother", this.selectAnother);
  }
};
</script>

<style scoped lang="scss">
.product-upload {
  @media (max-width: 767px) {
    padding-left: 0px;
    padding-right: 0px;
  }
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.uploadIcon {
  position: absolute;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.uploadDescription {
  font-size: 12px;
  line-height: 22px;
}
.receiptUploaderWrapper {
  border: 1px solid #dddfe1;
  box-sizing: border-box;
  border-radius: 4px;
  min-height: 240px;
  padding: 0;
  margin-bottom: 20px;
  width: 86%;
  .receiptScannerPlaceholder {
    color: #97999b;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.text-center {
  text-align: center !important;
}
.hidden {
  display: none;
}
.receipt-uploader {
  overflow: hidden;
}

.wrapper_square_img {
  position: relative;
  display: inline-block;
  width: 89%;
}
.delete_block {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.delete_block .delete_img {
  width: 16px;
}
.section-title {
  color: #474747;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.16px;
  text-align: center;
  margin-bottom: 30px;
}
.upload-canvas {
  box-sizing: border-box;
  height: 176px;
  border: 2px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  transition: background-color 0.5s;
  cursor: pointer;

  &:hover {
    background-color: #fff;
  }

  .upload-text {
    color: #474747;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.16px;
  }

  .upload-icon {
    text-align: center;
  }
}
.upload-hint {
  margin-top: 14px;
  opacity: 0.64;
  color: #474747;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.14px;
  line-height: 16px;
}
.inputfile {
  display: none;
}
.wrapper_file_upload {
  position: relative;
  height: 527px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0px 16px 32px -3px #e2e8f9;
  border-radius: 16px;
  padding: 25px;
  transition: background-color 300ms;
  &_prog {
    border-style: solid;
  }
  @media (max-width: 767px) {
    height: 480px;
    padding: 20px;
  }

  .file_upload {
    height: 100%;
    width: 100%;
    cursor: pointer;
    padding: 20px;
    background-color: var(--inputBacgroundColor);
    border: 1px dashed var(--borderColor);
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0;
    position: relative;

    .upload_content {
      position: absolute;
      top: 20%;
      span {
        color: var(--textColor);
      }
    }
    #button {
      position: absolute;
      bottom: 5%;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      height: 45px;
      width: 123px;
    }
  }

  .image_preview {
    height: 100%;
    width: 100%;
    cursor: pointer;
    background-color: #fbfcfe;
    border: 1px dashed var(--borderColor);
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .upload_content {
      position: absolute;
      top: 20%;
      span {
        color: #0f2967;
      }
    }
    img {
      max-height: 90%;
      display: block;
      margin: 0 auto;
    }

    .chooseButton {
      position: absolute;
      bottom: 15px;
      left: 24%;
      font-size: 16px;
    }
  }
}
.upload_img {
  width: 129px;
  margin-bottom: 30px;
}
.file_upload input[type="file"] {
display: none;
}
.color-green {
  color: var(--brand-color) !important;
}
.poz_rel {
  position: relative;
}
.container_sm {
  max-width: 710px !important;
}
</style>
